import request from '@/service/lib/request'

/**
 * @param {String} url 请求地址
 */
export function device(companyId) {
  return request({
    url: `/api/v2/camera-traps/`,
    method: 'get',
    params: { companyId }
  })
}

export function dayCount(companyId, month) {
  return request({
    url: '/api/v2/camera-traps/day-count',
    method: 'get',
    params: { companyId, month }
  })
}

export function imgs(query, page, limit) {
  return request({
    url: `/api/v2/camera-traps/imgs`,
    method: 'get',
    params: { ...query, page, limit }
  })
}

export function analyse(companyId, begin, end) {
  return request({
    url: `/api/v2/camera-traps/analyse`,
    method: 'get',
    params: { companyId, begin, end }
  })
}

export function last(companyId) {
  return request({
    url: `/api/v2/camera-traps/last`,
    method: 'get',
    params: { companyId }
  })
}
